import Banner from "./Sections/Banner";
import Why from "./Sections/Why";
import Community from "./Sections/Community";
import SocialNetworksAction from "./Sections/SocialNetworksAction";

const Home = () => {
  return (
    <>
      <Banner />
      <Why />
      <Community />
      {/* <SocialNetworksAction /> */}
    </>
  );
};

export default Home;
